import gql from "graphql-tag";

export const typeDefs = gql`
  extend type Query {
    error: Int
  }
`;

export const resolvers = {
  Query: {
    error: () => {
      return 0;
    },
  },
};
